import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-digital-id-activation-info",
	templateUrl: "./digital-id-activation-info.component.html",
	styleUrls: ["./digital-id-activation-info.component.css"],
})
export class DigitalIdActivationInfoComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.lstSchool = this.dialogConfig.data.lstTable;

		this.lstSchool = this.lstSchool.filter((school) => school.IsValid == false);
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchool: any;
	lstSchool: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
		{ field: "MissingEntries", header: "# of Missing Activations" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSendAnyways() {
		this.ref.close(1);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchool = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSchool = null;
	}
	////////////////////////////////////////////
}
